import React, { useState, useEffect } from "react";
import "./viewRating.scss";
import Header from "../../components/header/Header";
import PageHeading from "../../components/pageHeading/PageHeading";
import Footer from "../../components/footer/Footer";
import { BackIcon, EditIcon, StarOutline } from "../../components/Icons";
import UserImg from "../../assets/images/user.jpg";
import OverAllRating from "../../components/overAllRating/OverAllRating";
import Comments from "../../components/comments/Comments";
import {
  provider_getProfile,
  fetchUserRating,
} from "../../services/auth.service";
import { fetchImage, getFullName } from "../../utils/common";
import StarRating from "../../components/rating/StarRating";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
// import Pagination from 'react-bootstrap/Pagination';
import Pagination from "../../components/paginate/Paginate";
import "../../components/paginate/Paginate";
const Viewrating = () => {
  const [providerData, setProviderData] = useState(null);
  const [rating, setRating] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  let navigate = useNavigate();

  const providerProfile = async () => {
    const providerProfile = await provider_getProfile();
    // console.log("providerProfile=>", providerProfile.data);
    setProviderData(providerProfile.data);
  };

  //   const providerRating = async () => {
  //     let payload = {
  //       pageNumber: 1,
  //     };
  //     const constumerProfileRating = await fetchUserRating({ pageNumber: 1 });
  //     console.log("providerProfileRating=>", constumerProfileRating.data);
  //     setRating(constumerProfileRating.data.ratings);
  //     setTotalPages(constumerProfileRating.data.totalPages)
  //     setCurrentPage(pageNumber);
  //   };

  const providerRating = async (pageNumber) => {
    try {
      const constumerProfileRating = await fetchUserRating({ pageNumber });
      // console.log('constumerProfileRating',constumerProfileRating.data);
      setRating(constumerProfileRating.data.ratings);
      setTotalPages(constumerProfileRating.data.totalPages);
      setCurrentPage(pageNumber);
    } catch (error) {
      console.error("Error fetching ratings:", error);
    }
  };

  const handlePageChange = (pageNumber) => {
    providerRating(pageNumber);
  };

  useEffect(() => {
    providerProfile();
    providerRating(1);
  }, []);

  return (
    <>
      <Header />
      <PageHeading title="Rating" />
      <div className="main-container">
        <div className="container-wrap">
          <div className="view-rating-container">
            <div className="back-wrapper">
              {/* <div className='back-icon'><BackIcon /></div> */}

              <div className="back-title">
                {" "}
                <Button onClick={() => navigate("/consumer/profile")}>
                  Back
                </Button>
              </div>
            </div>
            <div className="view-rating-wrap box-wrapper">
              <div className="user-account-detail-top">
                <div className="user-img-wrap">
                  <div className="user-pic">
                    <img
                      src={fetchImage(providerData?.provider?.profilePic)}
                      alt="User"
                    />
                  </div>
                  <div className="edit-pic">
                    <EditIcon />
                  </div>
                </div>
                <div className="user-name-wrap">
                  <div className="username">
                    {getFullName(
                      providerData?.provider?.firstName,
                      providerData?.provider?.lastName
                    )}
                  </div>
                  <div className="user-rating-wrap">
                    <div className="rating">
                      {providerData !== null && (
                        <StarRating
                          rating={providerData?.provider?.ratingUser}
                        />
                      )}
                    </div>
                    <div className="view-rating">
                      ({providerData?.provider?.ratingUser}) -{" "}
                      <span>
                        {providerData?.provider?.userNumberOfRatings} Reviews
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="view-overall-rating-wrap">
                {providerData !== null && (
                  <OverAllRating data={providerData?.provider} />
                )}
              </div>

              {/* <div className="all-review-wrapper">
                <div className="all-review-title">All Reviews</div>
                <Comments rating={rating} />
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div> */}
            </div>
          </div>{" "}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Viewrating;
